import { Children, ReactNode } from "react";
import { Box, Divider } from "@mui/material";
import Section from "@/app/features/shared/snap-section/Section";
import SnapSectionsContainer from "@/app/features/shared/snap-section/SnapSectionsContainer";
import IntroAnchor from "@/app/features/shared/__to_be_integrated/ui/IntroAnchor";

interface PricingPageFrameProps {
    intro: ReactNode;
    categories: ReactNode;
    relatedInfos: ReactNode;
}

export function PricingPageFrame({ intro, categories, relatedInfos }: PricingPageFrameProps) {
    return (
        <SnapSectionsContainer>
            <Section className="relative">
                {intro}
            </Section>
            <IntroAnchor />
            {Children.map(categories, (category) => (
                <Box component="div">
                    <Box sx={{ px: { xs: 2, md: 4 }, py: 4 }} aria-hidden="true">
                        <Divider />
                    </Box>
                    {category}
                </Box>
            ))}
            {relatedInfos}
        </SnapSectionsContainer>
    );
}

interface PricingCategoryFrameProps {
    categoryId: string;
    index: number;
    content: ReactNode;
    image: ReactNode;
}

export function PricingCategoryFrame({
    categoryId,
    index,
    content,
    image,
}: PricingCategoryFrameProps) {
    const contentFirst = index % 2 === 0;

    return (
        <Section aria-labelledby={categoryId}>
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'repeat(2, minmax(0, 1fr))' },
                    minHeight: { xs: 'auto', md: '100%' },
                    height: { md: '100%' },
                    overflow: 'hidden',
                }}
            >
                <Box
                    sx={{
                        order: { xs: 1, md: contentFirst ? 1 : 2 },
                        display: 'flex',
                        alignItems: 'center',
                        minWidth: 0,
                        p: { xs: 3, sm: 5, md: 8, lg: 12 },
                    }}
                >
                    {content}
                </Box>
                <Box
                    sx={{
                        order: { xs: 2, md: contentFirst ? 2 : 1 },
                        position: 'relative',
                        minWidth: 0,
                        minHeight: { xs: '45svh', md: '100%' },
                    }}
                >
                    {image}
                </Box>
            </Box>
        </Section>
    );
}
